<div class="library-search-filters">
    <!-- button for open filters -->
    <app-helpers-search-filters-menu
      [filters]="filtersMenu"
      (chooseFilter)="onSelectFilter($event)"
   ></app-helpers-search-filters-menu>

   <!-- labels filters -->
   <app-helpers-search-filters-labels-main
      *ngIf="selectedFilter == 'label'"
      [available]="availableLabels"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-labels-main>
    <app-helpers-search-filters-status-main
      *ngIf="selectedFilter ==  'status'"
      [available]="availableStatus"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-status-main>
    <!-- maybe more filters here -->
</div>